/**
 * Determines if the first and last sidewalks in a street layout are "attached" to motor lanes.
 * A sidewalk is considered attached if it is directly adjacent to a motor lane, or if
 * it is separated from a motor lane only by a lamp post.
 *
 * @param {Array} segments - The array of street segments.
 * @param {Array<number>} sidewalkIndexArr - Indices of the sidewalk segments within the segments array.
 * @returns {Array<boolean>} An array containing two booleans: [isFirstSidewalkAttached, isLastSidewalkAttached].
 */
export function getFirstAndLastSidewalksAreAttached(segments, sidewalkIndexArr) {
  const MOTOR_LANE_TYPES = ['drive-lane', 'bus-lane']

  const isMotorLane = (type) => MOTOR_LANE_TYPES.includes(type)

  const firstSidewalkIndex = sidewalkIndexArr[0]
  const lastSidewalkIndex = sidewalkIndexArr[sidewalkIndexArr.length - 1]

  const firstSidewalkRightOneIndex = firstSidewalkIndex + 1
  const firstSidewalkRightTwoIndex = firstSidewalkIndex + 2
  const firstSidewalkRightOneType = segments[firstSidewalkRightOneIndex]?.type
  const firstSidewalkRightOneTypeIsMotorLane = isMotorLane(firstSidewalkRightOneType)
  const firstSidewalkRightTwoType = segments[firstSidewalkRightTwoIndex]?.type
  const firstSidewalkRightTwoTypeIsMotorLane = isMotorLane(firstSidewalkRightTwoType)
  const segmentsIncludesLampPlusOne = firstSidewalkRightOneType?.includes('lamp')

  const isFirstSidewalkAttached =
    firstSidewalkRightOneTypeIsMotorLane || (firstSidewalkRightTwoTypeIsMotorLane && segmentsIncludesLampPlusOne)

  const lastSidewalkLeftOneIndex = lastSidewalkIndex - 1
  const lastSidewalkLeftTwoIndex = lastSidewalkIndex - 2
  const lastSidewalkLeftOneType = segments[lastSidewalkLeftOneIndex]?.type
  const lastSidewalkLeftOneTypeIsMotorLane = isMotorLane(lastSidewalkLeftOneType)
  const lastSidewalkLeftTwoType = segments[lastSidewalkLeftTwoIndex]?.type
  const lastSidewalkLeftTwoTypeIsMotorLane = isMotorLane(lastSidewalkLeftTwoType)
  const segmentsIncludesLampMinusOne = lastSidewalkLeftOneType?.includes('lamp')

  const isLastSidewalkAttached =
    lastSidewalkLeftOneTypeIsMotorLane || (lastSidewalkLeftTwoTypeIsMotorLane && segmentsIncludesLampMinusOne)

  // console.log('isFirstSidewalkAttached, isLastSidewalkAttached', isFirstSidewalkAttached, isLastSidewalkAttached)
  // console.table([
  //   {
  //     type: firstSidewalkRightOneType,
  //     segment: firstSidewalkRightOneIndex,
  //     isMotorLane: firstSidewalkRightOneTypeIsMotorLane
  //   },
  //   {
  //     type: firstSidewalkRightTwoType,
  //     segment: firstSidewalkRightTwoIndex,
  //     isMotorLane: firstSidewalkRightTwoTypeIsMotorLane
  //   },
  //   {
  //     type: lastSidewalkLeftTwoType,
  //     segment: lastSidewalkLeftTwoIndex,
  //     isMotorLane: lastSidewalkLeftTwoTypeIsMotorLane
  //   },
  //   {
  //     type: lastSidewalkLeftOneType,
  //     segment: lastSidewalkLeftOneIndex,
  //     isMotorLane: lastSidewalkLeftOneTypeIsMotorLane
  //   }
  // ])
  // console.table(segments)
  return [isFirstSidewalkAttached, isLastSidewalkAttached]
}
